import React, { useEffect } from 'react';
// import AboutUs from './about-us';
import Feature from './Feature';
import Testimonial from './Testimonial';
import PricingPlanPage from './PricingPlan';
import Header from './Header';
import { Navbar } from './Navbar/Navbar';
import { Footer } from './Footer';
import WhyChooseWatchNod from './WhyChooseWatchNod';
import SEO from '../components/SEO';

function LandingRoute() {

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const section = document.querySelector(hash);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, []);


  return (
    <>
      <SEO
        title="WatchNod: Server Health & API Monitoring"
        description="WatchNod offers peak performance with our server monitoring solution. Enjoy real-time alerts, a user-friendly dashboard, 24/7 support, and customizable plans."
        url="/"
        type="website"
        image="/Logo/watch-nod.png"
      />
      <Navbar />
      <main>
        <Header />
        <Feature />
        <WhyChooseWatchNod />
        {/* <AboutUs /> */}
        <Testimonial />
        <PricingPlanPage />
      </main>
      <Footer />
    </>
  );
}

export default LandingRoute;
